import api from './api';

class TripShareService {
    // AI Chat functionality
    async sendChatMessage(message, sessionId) {
        try {
            const response = await api.post('/tripshare/chat', {
                message,
                sessionId
            });
            return response.data;
        } catch (error) {
            console.error('Error sending chat message:', error);
            throw error;
        }
    }

    // Get trip share details
    async getTripDetails(tripId) {
        try {
            const response = await api.get(`/tripshare/trip/${tripId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting trip details:', error);
            throw error;
        }
    }

    // Mark trip as helpful
    async markTripHelpful(tripId) {
        try {
            const response = await api.post(`/tripshare/trip/${tripId}/helpful`);
            return response.data;
        } catch (error) {
            console.error('Error marking trip helpful:', error);
            throw error;
        }
    }

    // Get agent's own trips
    async getMyTrips(page = 1, limit = 10) {
        try {
            const response = await api.get(`/tripshare/my-trips?page=${page}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error('Error getting my trips:', error);
            throw error;
        }
    }

    // Search trip shares
    async searchTrips(params) {
        try {
            const queryString = new URLSearchParams(params).toString();
            const response = await api.get(`/tripshare/search?${queryString}`);
            return response.data;
        } catch (error) {
            console.error('Error searching trips:', error);
            throw error;
        }
    }

    // Get popular destinations
    async getPopularDestinations() {
        try {
            const response = await api.get('/tripshare/popular-destinations');
            return response.data;
        } catch (error) {
            console.error('Error getting popular destinations:', error);
            throw error;
        }
    }

    // Upload photos for trip
    async uploadTripPhotos(tripId, formData) {
        try {
            const response = await api.post(`/tripshare/trip/${tripId}/photos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error uploading photos:', error);
            throw error;
        }
    }

    // Add supplier recommendation
    async addSupplierRecommendation(tripId, supplierData) {
        try {
            const response = await api.post(`/tripshare/trip/${tripId}/suppliers`, supplierData);
            return response.data;
        } catch (error) {
            console.error('Error adding supplier:', error);
            throw error;
        }
    }

    // Bookmark trip
    async bookmarkTrip(tripId, notes = '') {
        try {
            const response = await api.post(`/tripshare/trip/${tripId}/bookmark`, { notes });
            return response.data;
        } catch (error) {
            console.error('Error bookmarking trip:', error);
            throw error;
        }
    }

    // Get bookmarked trips
    async getBookmarkedTrips() {
        try {
            const response = await api.get('/tripshare/bookmarks');
            return response.data;
        } catch (error) {
            console.error('Error getting bookmarks:', error);
            throw error;
        }
    }

    // Get analytics
    async getAnalytics() {
        try {
            const response = await api.get('/tripshare/analytics');
            return response.data;
        } catch (error) {
            console.error('Error getting analytics:', error);
            throw error;
        }
    }

    // Generate session ID for chat
    generateSessionId() {
        return 'tripshare_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
}

export default new TripShareService();
